import { successAddBareme, serverError } from './../../core/models/messages';
import { SalarieService } from './../../core/services/salarie-service/salarie.service';
import { EsnJobOfferService } from './../../core/services/esn-job-offer-service/esn-job-offer.service';
import { Component } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
export function duplicateSkillValidator(formArray: AbstractControl): ValidationErrors | null {
  const skills = formArray as FormArray;
  const skillIds = new Set<number>();

  for (let i = 0; i < skills.length; i++) {
    const skillControl = skills.at(i);
    const skillId = skillControl.get('skill_job_id')?.value;

    if (skillId && skillIds.has(skillId)) {
      skillControl.get('skill_job_id')?.setErrors({ duplicateSkill: true });
    } else {
      skillIds.add(skillId);
      skillControl.get('skill_job_id')?.setErrors(null);
    }
  }
  return null;
}
export function duplicateavailabilityValidator(formArray: AbstractControl): ValidationErrors | null {
  const skills = formArray as FormArray;
  const skillIds = new Set<number>();

  for (let i = 0; i < skills.length; i++) {
    const skillControl = skills.at(i);
    const skillId = skillControl.get('availability')?.value;

    if (skillId && skillIds.has(skillId)) {
      skillControl.get('availability')?.setErrors({ duplicateavailability: true });
    } else {
      skillIds.add(skillId);
      skillControl.get('availability')?.setErrors(null);
    }
  }
  return null;
}
export function duplicatelanguesValidator(formArray: AbstractControl): ValidationErrors | null {
  const skills = formArray as FormArray;
  const skillIds = new Set<number>();

  for (let i = 0; i < skills.length; i++) {
    const skillControl = skills.at(i);
    const skillId = skillControl.get('language')?.value;

    if (skillId && skillIds.has(skillId)) {
      skillControl.get('language')?.setErrors({ duplicatelanguage: true });
    } else {
      skillIds.add(skillId);
      skillControl.get('language')?.setErrors(null);
    }
  }
  return null;
}
@Component({
  selector: 'app-call-offre-bareme',
  templateUrl: './call-offre-bareme.component.html',
  styleUrls: ['./call-offre-bareme.component.css'],
})
export class CallOffreBaremeComponent {
  BaremeForm: FormGroup = this.createBaremeForm();
  formData = new FormData();
  jobId: any;
  selectedBarem!: number;
  skillsList: { name_FR: string }[] = [];
  private unsubscribeAll: Subject<void> = new Subject();
  disponibilite = [
    { id: 1, name: 'Immédiate' ,value: '1'},
    { id: 2, name: '2 mois' ,value: '2' },
    { id: 3, name: '3 mois',value: '3' },
    { id: 4, name: '4 mois',value: '4' },
    { id: 5, name: '5 mois' , value: '5'},
  ];
   state :string=''
  languages = [
    { id: 1, name: 'Abkhaze' },
    { id: 2, name: 'Afrikaans' },
    { id: 3, name: 'Albanais' },
    { id: 4, name: 'Allemand' },
    { id: 5, name: 'Amharique' },
    { id: 6, name: 'Anglais' },
    { id: 7, name: 'Arabe' },
    { id: 8, name: 'Arménien' },
    { id: 9, name: 'Assamais' },
    { id: 10, name: 'Aymara' },
    { id: 11, name: 'Azéri' },
    { id: 12, name: 'Basque' },
    { id: 13, name: 'Bengali' },
    { id: 14, name: 'Biélorusse' },
    { id: 15, name: 'Birman' },
    { id: 16, name: 'Bosniaque' },
    { id: 17, name: 'Bulgare' },
    { id: 18, name: 'Catalan' },
    { id: 19, name: 'Cebuano' },
    { id: 20, name: 'Chewa' },
    { id: 21, name: 'Chichewa' },
    { id: 22, name: 'Chinois' },
    { id: 23, name: 'Coréen' },
    { id: 24, name: 'Corse' },
    { id: 25, name: 'Croate' },
    { id: 26, name: 'Danois' },
    { id: 27, name: 'Dzongkha' },
    { id: 28, name: 'Espagnol' },
    { id: 29, name: 'Estonien' },
    { id: 30, name: 'Finnois' },
    { id: 31, name: 'Flamand' },
    { id: 32, name: 'Français' },
    { id: 33, name: 'Frison' },
    { id: 34, name: 'Gaélique' },
    { id: 35, name: 'Galicien' },
    { id: 36, name: 'Géorgien' },
    { id: 37, name: 'Grec' },
    { id: 38, name: 'Groenlandais' },
    { id: 39, name: 'Gujarati' },
    { id: 40, name: 'Haoussa' },
    { id: 41, name: 'Hébreu' },
    { id: 42, name: 'Hindi' },
    { id: 43, name: 'Hmong' },
    { id: 44, name: 'Hongrois' },
    { id: 45, name: 'Ibo' },
    { id: 46, name: 'Islandais' },
    { id: 47, name: 'Indonésien' },
    { id: 48, name: 'Inuktitut' },
    { id: 49, name: 'Italien' },
    { id: 50, name: 'Japonais' },
    { id: 51, name: 'Javanais' },
    { id: 52, name: 'Kannada' },
    { id: 53, name: 'Kashmiri' },
    { id: 54, name: 'Kazakh' },
    { id: 55, name: 'Khmer' },
    { id: 56, name: 'Kinyarwanda' },
    { id: 57, name: 'Kirghize' },
    { id: 58, name: 'Kirundi' },
    { id: 59, name: 'Kurde' },
    { id: 60, name: 'Laotien' },
    { id: 61, name: 'Latin' },
    { id: 62, name: 'Letton' },
    { id: 63, name: 'Lituanien' },
    { id: 64, name: 'Luxembourgeois' },
    { id: 65, name: 'Macédonien' },
    { id: 66, name: 'Malais' },
    { id: 67, name: 'Malayalam' },
    { id: 68, name: 'Malgache' },
    { id: 69, name: 'Maltais' },
    { id: 70, name: 'Maori' },
    { id: 71, name: 'Marathi' },
    { id: 72, name: 'Mongol' },
    { id: 73, name: 'Néerlandais' },
    { id: 74, name: 'Népalais' },
    { id: 75, name: 'Norvégien' },
    { id: 76, name: 'Ouzbek' },
    { id: 77, name: 'Pachtou' },
    { id: 78, name: 'Papiamento' },
    { id: 79, name: 'Pashto' },
    { id: 80, name: 'Persan (farsi)' },
    { id: 81, name: 'Polonais' },
    { id: 82, name: 'Portugais' },
    { id: 83, name: 'Punjabi' },
    { id: 84, name: 'Quechua' },
    { id: 85, name: 'Roumain' },
    { id: 86, name: 'Russe' },
    { id: 87, name: 'Somali' },
    { id: 88, name: 'Samoan' },
    { id: 89, name: 'Sanskrit' },
    { id: 90, name: 'Serbe' },
    { id: 91, name: 'Sesotho' },
    { id: 92, name: 'Shona' },
    { id: 93, name: 'Sindhi' },
    { id: 94, name: 'Slovaque' },
    { id: 95, name: 'Slovène' },
    { id: 96, name: 'Sotho' },
    { id: 97, name: 'Soundanais' },
    { id: 98, name: 'Suédois' },
    { id: 99, name: 'Swahili' },
    { id: 100, name: 'Tadjik' },
  ];
  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private jobOfferService: EsnJobOfferService,
    private salarieService: SalarieService,
    private router: Router
  ) {}

  ngOnInit() {
    this.getListSkills();
    this.getId();
    if(this.state === 'update'){
      this.getBarem();
    }
  }

  /* get id  from route */
  getId() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.jobId = params.params['job_request_id'];
        this.state = params.params['state'];
        console.log("job id", this.jobId )
      },
    });
  }
  hasDuplicateSkillErrors(): boolean {
    const skillScoreArray = this.BaremeForm.get('skill_score') as FormArray;

    const skillJobIds = skillScoreArray.controls.map(
      (control) => control.get('skill_job_id')!.value
    );

    const duplicates = skillJobIds.filter(
      (id, index) => id && skillJobIds.indexOf(id) !== index
    );

    return duplicates.length > 0;
  }

  hasDuplicateavaibilityErrors(): boolean {
    const skillScoreArray = this.BaremeForm.get(
      'availibility_score'
    ) as FormArray;

    const skillJobIds = skillScoreArray.controls.map(
      (control) => control.get('availability')!.value
    );

    const duplicates = skillJobIds.filter(
      (id, index) => id && skillJobIds.indexOf(id) !== index
    );

    return duplicates.length > 0;
  }

  hasDuplicatelangueErrors(): boolean {
    const skillScoreArray = this.BaremeForm.get('language_score') as FormArray;

    const skillJobIds = skillScoreArray.controls.map(
      (control) => control.get('language')!.value
    );

    const duplicates = skillJobIds.filter(
      (id, index) => id && skillJobIds.indexOf(id) !== index
    );

    return duplicates.length > 0;
  }

  
  getBarem() {
    this.spinner.show();
    this.jobOfferService
      .getBaremClient(this.jobId)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res: any) => {
          this.selectedBarem = res.data;
          this.BaremeForm = this.createBaremeForm(this.selectedBarem);
          this.BaremeForm.get('test_qcm_score')?.setValue(res.data.test_qcm_score[0]?res.data.test_qcm_score[0].test_qcm_score : '')
          this.spinner.hide();
          console.log('my form', this.BaremeForm.value)
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  createFormLangues(data?: any): FormGroup {
    const formGroup =this.formBuilder.group({
      language: [data ? data.language : null],
      coef: [ data ? String(data.coef) : null]
    });
    if(formGroup.get('language')!.value == null){

      formGroup.get('coef')!.disable();
    }
    formGroup.get('language')!.valueChanges.subscribe((value) => {
      if (value) {
        formGroup.get('coef')!.enable();
      } else {
        formGroup.get('coef')!.disable();
        formGroup.get('coef')!.reset();
      }
    });

    return formGroup;
  }
 
  createFormSkills(data?: any): FormGroup {
    const formGroup = this.formBuilder.group({
      skill_job_id: [data ? data.skill_job_id : null],
      coef: [ data ? String(data.coef) : null]
    });
    if(formGroup.get('skill_job_id')!.value == null){

      formGroup.get('coef')!.disable();
    }
    formGroup.get('skill_job_id')!.valueChanges.subscribe((value) => {
      if (value) {
        formGroup.get('coef')!.enable();
      } else {
        formGroup.get('coef')!.disable();

        formGroup.get('coef')!.reset();
      }
    });

    return formGroup;
  }
  createFormAvailability(data?: any) : FormGroup{
    const formGroup =  this.formBuilder.group({
      availability: [data ? data.availability : null],
      coef: [ data ? String(data.coef) : null]
    });
    if(formGroup.get('availability')!.value == null){

      formGroup.get('coef')!.disable();
    }
    formGroup.get('availability')!.valueChanges.subscribe((value) => {
      if (value) {
        formGroup.get('coef')!.enable();
      } else {
        formGroup.get('coef')!.disable();
        formGroup.get('coef')!.reset();
      }
    });

    return formGroup;
    
  }
  createFormExperience(data?: any):FormGroup {
    const formGroup = this.formBuilder.group({
      year_experience: [data ? String(data.year_experience) : null],
      coef: [ data ? String(data.coef) : null]
    });
    if(formGroup.get('year_experience')!.value == null){

      formGroup.get('coef')!.disable();
    }
    formGroup.get('year_experience')!.valueChanges.subscribe((value) => {
      if (value) {
        formGroup.get('coef')!.enable();
      } else {
        formGroup.get('coef')!.disable();
        formGroup.get('coef')!.reset();
      }
    });

    return formGroup;
  }

  addSkills() {
    const skills = this.BaremeForm.get('skill_score') as FormArray;
    skills.push(this.createFormSkills());
  }
  addLangues() {
    const language_score = this.BaremeForm.get('language_score') as FormArray;
    language_score.push(this.createFormLangues());
  }
  addAvailability() {
    const availibility_score = this.BaremeForm.get(
      'availibility_score'
    ) as FormArray;
    availibility_score.push(this.createFormAvailability());
  }
  addExperiences() {
    const experience_score = this.BaremeForm.get(
      'experience_score'
    ) as FormArray;
    experience_score.push(this.createFormExperience());
  }

  get skillsControls(): AbstractControl<any, any>[] {
    return (this.BaremeForm.get('skill_score') as FormArray)?.controls || [];
  }
  get availibility_scoreControls(): AbstractControl<any, any>[] {
    return (
      (this.BaremeForm.get('availibility_score') as FormArray)?.controls || []
    );
  }
  get experiencesControls(): AbstractControl<any, any>[] {
    return (
      (this.BaremeForm.get('experience_score') as FormArray)?.controls || []
    );
  }
  get langueControls(): AbstractControl<any, any>[] {
    return (this.BaremeForm.get('language_score') as FormArray)?.controls || [];
  }
  removescoreQCM(index: number) {
    const ScoreQCM = this.BaremeForm.get('test_qcm_score') as FormArray;
    ScoreQCM.removeAt(index);
  }
  removeSkills(index: number) {
    const skills = this.BaremeForm.get('skill_score') as FormArray;
    skills.removeAt(index);
  }
  removeAvailability(index: number) {
    const availibility_score = this.BaremeForm.get(
      'availibility_score'
    ) as FormArray;
    availibility_score.removeAt(index);
  }
  removeExperiences(index: number) {
    const experience_score = this.BaremeForm.get(
      'experience_score'
    ) as FormArray;
    experience_score.removeAt(index);
  }
  removeLangue(index: number) {
    const language_score = this.BaremeForm.get('language_score') as FormArray;
    language_score.removeAt(index);
  }
  createBaremeForm(data?: any) {
    const skillScoreArray = this.formBuilder.array(
      Array.isArray(data?.skill_score) && data?.skill_score.length
        ? data.skill_score.map((item: any) => this.createFormSkills(item))
        : [this.createFormSkills()]
    );
  
    // Ajout de la validation pour les compétences dupliquées
    skillScoreArray.setValidators(duplicateSkillValidator);
    const skillavaibilityArray = this.formBuilder.array(
      Array.isArray(data?.availibility_score) && data?.availibility_score.length
        ? data.availibility_score.map((item: any) => this.createFormAvailability(item))
        : [this.createFormAvailability()]
    );
  

    skillavaibilityArray.setValidators(duplicateavailabilityValidator);

    const skilllanguersArray = this.formBuilder.array(
      Array.isArray(data?.language_score) && data?.language_score.length
        ? data.language_score.map((item: any) => this.createFormLangues(item))
        : [this.createFormLangues()]
    );
  
    // Ajout de la validation pour les compétences dupliquées
    skilllanguersArray.setValidators(duplicatelanguesValidator);
  
    return this.formBuilder.group({
      job_request_id: [data ? data.job_request_id : ''],
      test_qcm_score: [data ?data.test_qcm_score: ''],
      skill_score: skillScoreArray,
      availibility_score:skillavaibilityArray,
      language_score:skilllanguersArray,
      // availibility_score: this.formBuilder.array(
      //   Array.isArray(data?.availibility_score) &&
      //     data?.availibility_score.length
      //     ? data.availibility_score.map((item: any) =>
      //         this.createFormAvailability(item)
      //       )
      //     : [this.createFormAvailability()]
      // ),
      experience_score: this.formBuilder.array(
        Array.isArray(data?.experience_score) && data?.experience_score.length
          ? data.experience_score.map((item: any) =>
              this.createFormExperience(item)
            )
          : [this.createFormExperience()]
      ),
      // language_score: this.formBuilder.array(
      //   Array.isArray(data?.language_score) && data?.language_score.length
      //     ? data.language_score.map((item: any) => this.createFormLangues(item))
      //     : [this.createFormLangues()]
      // ),
    });
  }
  
  // Helper function to convert coef values to strings
  convertCoefToString(data: any): any {
    if (data.skill_score) {
      data.skill_score = data.skill_score.map((item: any) => ({
        ...item,
        coef: String(item.coef),
      }));
    }

    if (data.availibility_score) {
      data.availibility_score = data.availibility_score.map((item: any) => ({
        ...item,
        coef: String(item.coef),
      }));
    }

    if (data.experience_score) {
      data.experience_score = data.experience_score.map((item: any) => ({
        year_experience: String(item.year_experience),
        coef: String(item.coef),
      }));
    }

    if (data.language_score) {
      data.language_score = data.language_score.map((item: any) => ({
        ...item,
        coef: String(item.coef),
      }));
    }

    return data;
  }

  addBareme() {
    if (this.jobId !== null) {
      this.BaremeForm.patchValue({ job_request_id: this.jobId });
    }

    let baremeData = this.BaremeForm.value;

    console.log('my form to add', this.BaremeForm.value)

  
    // Convertir les coefficients en chaînes
    baremeData = this.convertCoefToString(baremeData);
  
    // Nettoyer les tableaux en supprimant les valeurs nulles ou non valides
    baremeData.skill_score = this.cleanArray(baremeData.skill_score);
    baremeData.availibility_score = this.cleanArray(baremeData.availibility_score);
    baremeData.experience_score = this.cleanArray(baremeData.experience_score);
    baremeData.language_score = this.cleanArray(baremeData.language_score);
    console.log('my form after test', baremeData)

    this.jobOfferService
      .addBaremeClient(baremeData)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.toastrService.success(successAddBareme);
            this.router.navigateByUrl("/liste-appels-offres")
// this.navigateToDetailoffre(this.jobId)
          }
        },
        error: (err) => {
          console.log('error', err);
          if (
            err.error &&
            err.error.message == 'Duplicate skills values found'
          ) {
            this.toastrService.error(
              'Des compétences en double ont été détectées.'
            );
          } 
          if (
            err.error &&
            err.error.message == 'Duplicate languages values found'
          ) {
            this.toastrService.error(
              'Des languages en double ont été détectées.'
            );
          } 
        
          if (
            err.error &&
            err.error.message == 'Duplicate availabilities values found'
          ) {
            this.toastrService.error(
              'Des Disponibilités en double ont été détectées.'
            );
          }
          
        },
      });
  }

  navigateToDetailoffre(consultantId: any) {
    this.router.navigate([
      'detail-offre-clientfinal',
      consultantId]);
  }
  cleanArray(array: any[]): any[] {
    if (array && Array.isArray(array)) {
      console.log('my array',array)
      return array.filter(item => item !== null && item !== undefined && item.coef !== 'undefined');
    }
    return [];
  }
  isFormValid(): boolean {
    // Validation pour chaque groupe de contrôles
    const skillsValid = this.skillsControls.some(control => {
      const skillSelected = control.get('skill_job_id')?.value;
      const coefFilled = control.get('coef')?.value;
      return skillSelected && coefFilled !== null && coefFilled !== '';
    });
  
    const availabilityValid = this.availibility_scoreControls.some(control => {
      const availabilitySelected = control.get('availability')?.value;
      const coefFilled = control.get('coef')?.value;
      return availabilitySelected && coefFilled !== null && coefFilled !== '';
    });
  
    const experienceValid = this.experiencesControls.some(control => {
      const yearExperience = control.get('year_experience')?.value;
      const coefFilled = control.get('coef')?.value;
      return yearExperience && coefFilled !== null && coefFilled !== '';
    });
  
    const languageValid = this.langueControls.some(control => {
      const languageSelected = control.get('language')?.value;
      const coefFilled = control.get('coef')?.value;
      return languageSelected && coefFilled !== null && coefFilled !== '';
    });
  
    const testQCMScore = this.BaremeForm.get('test_qcm_score')?.value;
    const isTestQCMScoreValid = testQCMScore !== null && testQCMScore !== '';
  
    // Vérifier que toutes les saisies qui ont des valeurs ont des coefs valides
    const areAllCoefficientsValid = [
      ...this.skillsControls,
      ...this.availibility_scoreControls,
      ...this.experiencesControls,
      ...this.langueControls
    ].every(control => {
      const coefControl = control.get('coef');
      const valueControl = control.get('skill_job_id')?.value || control.get('availability')?.value || control.get('year_experience')?.value || control.get('language')?.value;
      // Si une valeur est entrée, le coefficient doit être non nul et non vide
      return valueControl ? coefControl?.value !== null && coefControl?.value !== '' : true;
    });
  
    // Le formulaire est valide si au moins une section est remplie correctement et tous les coefficients requis sont présents
    return (
    
      areAllCoefficientsValid
    );
  }
  
  
  getListSkills() {
    this.salarieService
      .getSkillsJobs()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.skillsList = res.data;
        },
        error: () => {},
      });
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
